var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgCalendar = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 24,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M41.091,344H41a1,1,0,0,0-2,0H37a1,1,0,0,0-2,0H33a1,1,0,0,0-2,0h-.091A2.9,2.9,0,0,0,28,346.95v9.1A2.9,2.9,0,0,0,30.909,359H41.091A2.9,2.9,0,0,0,44,356.05v-9.1A2.9,2.9,0,0,0,41.091,344ZM42,356.05a.9.9,0,0,1-.909.95H30.909a.9.9,0,0,1-.909-.95V356h2a1,1,0,0,0,0-2H30v-1h2a1,1,0,0,0,0-2H30v-1h9a1,1,0,0,0,0-2H30v-1.05a.9.9,0,0,1,.909-.95H31a1,1,0,0,0,2,0h2a1,1,0,0,0,2,0h2a1,1,0,0,0,2,0h.091a.9.9,0,0,1,.909.95V351H40a1,1,0,0,0,0,2h2v1H40a1,1,0,0,0,0,2h2ZM38,352a1,1,0,0,1-1,1H35a1,1,0,0,1,0-2h2A1,1,0,0,1,38,352Zm0,3a1,1,0,0,1-1,1H35a1,1,0,0,1,0-2h2A1,1,0,0,1,38,355Z",
    transform: "translate(-24 -339)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.3d1c28dc.svg";
export { ForwardRef as ReactComponent };